import { Time } from '@instinet-analytics/core-lib';
import { WidgetStateWithRequestSymbology } from 'widgets/WidgetSymbologyWarning';
import { AverageExecPriceBenchmarkReferenceValues } from 'widgets/portfolioReturns/averageExecPriceBenchmark';

export interface PortfolioReturnsComponentState
    extends WidgetStateWithRequestSymbology {
    fromDate?: Date;
    toDate?: Date;
    basisTime?: Time;
    basisDay?: Date;
    avgExecRefValues?: AverageExecPriceBenchmarkReferenceValues;
}

export const initialPortfolioReturnsComponentState: PortfolioReturnsComponentState =
    {};
